'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = restartPlayables;

var _store = require('../../../store');

var _store2 = _interopRequireDefault(_store);

var _ = require('./');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function restartPlayables(playerId) {
  var player = _store2.default.storeInstance().getState().players[playerId];

  if (player.autoAdvance && player.playingIndex !== 0) {
    // Restart the playlist
    return function (dispatch) {
      dispatch((0, _.setQueueEnded)(playerId));
      dispatch((0, _.setPlayingIndex)(playerId, 0));
      dispatch((0, _.play)(playerId));
    };
  }

  // Restart the current playable
  return function (dispatch) {
    dispatch((0, _.setQueueEnded)(playerId));
    dispatch((0, _.setCurrentTimeMs)(playerId, 0));
    dispatch((0, _.play)(playerId));
  };
}
module.exports = exports['default'];